module.exports = __webpack_public_path__ + "img/76.29fc225a.png";